import React, { AriaRole } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface LazyImgixImageProps {
  alt?: string;
  className?: string;
  role?: AriaRole;
  src: string;
  sizes?: string;
  wrapperClassName?: string;
}

const LazyImgixImage = ({
  alt,
  className,
  role,
  src,
  sizes,
  wrapperClassName,
}: LazyImgixImageProps) => {
  const isGif = src.endsWith('.gif');
  const imageSrc = `${src}?auto=compress&fit=crop&${isGif ? 'gif-q=50' : 'auto=format'}`;
  const placeholderSrc = `${src}?auto=compress,format&fit=crop&w=800&blur=200`;
  const srcSet = `${imageSrc}&w=400&dpr=0.75 240w,
    ${imageSrc}&w=400&dpr=1 480w,
    ${imageSrc}&w=400&dpr=1.5 576w,
    ${imageSrc}&w=400&dpr=2 768w,
    ${imageSrc}&w=400&dpr=2.5 992w,
    ${imageSrc}&w=400&dpr=3 1200w,
    ${imageSrc}&w=400&dpr=3.5 1350w,
    ${imageSrc}&w=400&dpr=4 1500w,
    ${imageSrc}&w=400&dpr=4.5 1750w`;

  return (
    <LazyLoadImage
      alt={alt}
      loading="lazy"
      className={className}
      wrapperClassName={wrapperClassName}
      role={role}
      src={imageSrc}
      srcSet={srcSet}
      sizes={sizes}
      placeholderSrc={placeholderSrc}
    />
  );
};

export default LazyImgixImage;
